var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 9,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 3H4V15.15H12.59V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26995 13.8702C8.25995 15.2502 5.47995 13.7002 5.01995 12.1502H5.04995C4.56995 10.5402 4.66995 8.9502 5.26995 7.4202C6.64995 3.8602 10.16 2.5302 11.63 5.0702C11.73 5.2402 11.7699 5.46021 11.8099 5.69021C11.9499 6.37021 11.44 7.2002 10.96 7.8102C10.05 8.9602 9.64995 10.4602 9.76995 11.9702C9.81995 12.5902 9.80995 13.1402 9.26995 13.8802V13.8702Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 9,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9494 3H15.3594V15.15H23.9494V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.669 13.8702C19.679 15.2502 22.459 13.7002 22.919 12.1502H22.889C23.369 10.5402 23.269 8.9502 22.669 7.4202C21.289 3.8602 17.779 2.5302 16.309 5.0702C16.209 5.2402 16.169 5.46021 16.129 5.69021C15.989 6.37021 16.499 7.2002 16.979 7.8102C17.889 8.9602 18.289 10.4602 18.169 11.9702C18.119 12.5902 18.129 13.1402 18.669 13.8802V13.8702Z",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2071_20535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 7,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2095 7.96973H7.18945V20.7297H13.2095V7.96973Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2071_20535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93945 8.71973L12.4595 10.8297L12.4395 19.9797",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2071_20535",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 7,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7485 7.96973H14.7285V20.7297H20.7485V7.96973Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2071_20535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0085 8.71973L15.4785 10.8297L15.4985 19.9797",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneys);
export default __webpack_public_path__ + "static/media/Kidneys.11f30b6da0b8a4baa4ce2a16dd7961b3.svg";
export { ForwardRef as ReactComponent };